module.exports = __webpack_public_path__ + "static/img/twjd-sdo11-1.3b398e7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sdo11-1.png
// module id = 233
// module chunks = 0